/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DocumentsControllerHealthCheck$Params {
}

export function documentsControllerHealthCheck(http: HttpClient, rootUrl: string, params?: DocumentsControllerHealthCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'status'?: string;
'timestamp'?: number;
'service'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, documentsControllerHealthCheck.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'status'?: string;
      'timestamp'?: number;
      'service'?: string;
      }>;
    })
  );
}

documentsControllerHealthCheck.PATH = '/thalea-documents/documents/health';
